import React from 'react';

const CONTACTS = [
  {
    title: 'Email',
    value: 'milyasdev94@gmail.com',
    cta:   'Send a message',
    href:  'mailto:milyasdev94@gmail.com',
    icon: (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
      </svg>
    ),
  },
  {
    title: 'WhatsApp',
    value: '+92 349 052 3972',
    cta:   'Start a conversation',
    href:  'https://wa.me/923490523972',
    icon: (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    ),
  },
];

const SOCIALS = [
  {
    label: 'GitHub',
    href: 'https://github.com/IlyasDev123',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 0C5.37 0 0 5.373 0 12c0 5.303 3.438 9.8 8.205 11.387.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222 0 1.606-.015 2.896-.015 3.286 0 .322.216.694.825.576C20.565 21.795 24 17.298 24 12c0-6.627-5.373-12-12-12z" />
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/muhammad-ilyas-873a17178',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
];

export default function ContactUs() {
  return (
    <section id="contact" className="py-16 lg:py-24 bg-slate-950">
      <div className="max-w-6xl mx-auto px-5 sm:px-6">

        <p className="font-mono text-sky-400 text-xs sm:text-sm tracking-widest mb-2">06. Contact</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-100 mb-3 sm:mb-5">Get in touch</h2>
        <p className="text-slate-400 text-sm sm:text-base max-w-xl mb-3 sm:mb-4">
          I'm currently open to new opportunities. Whether you have a project in mind,
          a question, or just want to say hi — my inbox is always open.
        </p>
        <p className="font-mono text-xs sm:text-sm text-slate-600 mb-8 sm:mb-12">
          Availability: <span className="text-slate-400">30-day notice · Lahore, Pakistan</span>
        </p>

        <div className="grid sm:grid-cols-2 gap-3 sm:gap-5 max-w-2xl mb-8 sm:mb-14">
          {CONTACTS.map(c => (
            <a
              key={c.title}
              href={c.href}
              target={c.href.startsWith('http') ? '_blank' : undefined}
              rel={c.href.startsWith('http') ? 'noopener noreferrer' : undefined}
              className="group flex items-start gap-3 sm:gap-4 bg-slate-900 border border-slate-800 hover:border-sky-500/50 rounded-xl p-4 sm:p-6 transition-all hover:bg-slate-800/80"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-sky-500/10 border border-sky-500/20 text-sky-400 flex items-center justify-center shrink-0 group-hover:bg-sky-500 group-hover:text-white group-hover:border-sky-500 transition-all">
                {c.icon}
              </div>
              <div className="min-w-0">
                <p className="text-slate-200 font-semibold text-sm sm:text-base mb-0.5">{c.title}</p>
                <p className="text-slate-500 text-xs sm:text-sm mb-1.5 sm:mb-2 font-mono truncate">{c.value}</p>
                <p className="text-sky-400 text-xs sm:text-sm font-medium flex items-center gap-1.5">
                  {c.cta}
                  <svg
                    className="w-3 h-3 sm:w-3.5 sm:h-3.5 group-hover:translate-x-1 transition-transform shrink-0"
                    fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                  </svg>
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3 sm:gap-4">
          <span className="text-slate-600 text-[10px] sm:text-xs font-mono uppercase tracking-widest whitespace-nowrap">Also on</span>
          {SOCIALS.map(s => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-slate-900 border border-slate-800 hover:border-sky-500/50 text-slate-500 hover:text-sky-400 flex items-center justify-center transition-all"
            >
              {s.icon}
            </a>
          ))}
        </div>

      </div>
    </section>
  );
}
